<template>
	<div class="payResult" v-loading.fullscreen.lock="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<banner></banner>
		<div v-if="result_type === '1'" class="success">
			<div class="result">
				<div class="wrap">
					<img src="../../static/images/success-icon.png" alt="" />
					<p class="title">{{$t('payResult.suc.title')}}</p>
					<div class="con">
						<div class="box">
							<ul>
								<li><span>{{$t('payResult.suc.order_id')}}</span>{{pay_order_id}}</li>
								<!--<li><span>{{$t('payResult.suc.auth_code')}}</span>{{auth_code}}</li>-->
								<li><span>{{$t('payResult.suc.pkgName')}}</span>{{pkgName}}</li>
								<li class="red"><span>{{$t('payResult.suc.amount')}}</span>{{amount}}</li>
							</ul>
						</div>
						<router-link :to="{name: 'index'}" class="back">{{$t('btn.act_back')}}</router-link>
					</div>
				</div>
			</div>
			<div class="actStep" v-if="activeFlag=='online'">
				<p class="title">{{$t('payResult.suc.act_title')}}</p>
				<p class="hidden-xs-only"><img src="../../static/images/act-steps-pc.png" v-if="$i18n.locale == 'zh'"/><img src="../../static/images/act-steps-pc-hk.png" v-if="$i18n.locale == 'hk'"/></p>
				<p class="hidden-sm-and-up step_m" v-if="$i18n.locale == 'zh'">
					<img src="../../static/images/act-steps-m-1.png"/>
					<img src="../../static/images/act-steps-m-2.png"/>
					<img src="../../static/images/act-steps-m-3.png"/>
					<img src="../../static/images/act-steps-m-4.png"/>
				</p>
				<p class="hidden-sm-and-up step_m" v-if="$i18n.locale == 'hk'">
					<img src="../../static/images/act-steps-m-1-hk.png"/>
					<img src="../../static/images/act-steps-m-2-hk.png"/>
					<img src="../../static/images/act-steps-m-3-hk.png"/>
					<img src="../../static/images/act-steps-m-4-hk.png"/>
				</p>
			</div>
			<div class="tips">
				<div class="wrap">
					<div class="con">
						<img src="../../static/images/code-ct.png"/>
						<div class="words">
							<p>{{$t('payResult.suc.tips[0]')}}<span>{{$t('payResult.suc.tips[1]')}}</span>，<br />{{$t('payResult.suc.tips[2]')}}。</p>
							<p>{{$t('payResult.suc.tips[3]')}}<br />{{$t('payResult.suc.tips[4]')}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="result_type === '0'" class="fail">
			<div class="result">
				<div class="wrap">
					<img src="../../static/images/fail-icon.png" alt="" />
					<p class="title">{{$t('payResult.fail.title')}}</p>
					<div class="con">
						<div class="box">
							<ul>
								<li style="font-weight: 700;">请审核以下信息</li>
								<li>1.银行卡信息是否填写正确</li>
								<li>2.银行卡信息未审核通过，可能存在余额不足等原因</li>
							</ul>
						</div>
						<p class="lastStep"><a href="javascript:history.back(-1)">{{$t('btn.return_last')}}</a></p>
						<p style="text-align: center;margin-top: 12px;">{{$t('payResult.fail.tips[0]')}}</p>
						<p style="text-align: center;">{{$t('payResult.fail.tips[1]')}}</p>
						<router-link :to="{name: 'index'}" class="back">{{$t('btn.act_back')}}</router-link>
					</div>
				</div>
			</div>
		</div>
		<footer>{{$t('footer')}}</footer>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getPaypalStatus, getOrderInfo } from '@/api/api'
import '@/common/js/rem'
import banner from '@/components/banner'
import 'element-ui/lib/theme-chalk/display.css'
export default {
  name: 'index',
  components: {
  	banner
  },
  data () {
    return {
    	loading: true,
    	result_type: '',//0是失败页面 1是成功页面
    	pay_order_id: '',//支付订单id
    	auth_code: '',//认证码
    	recom_code: '',//推荐码
    	amount: '',//金额
    }
  },
  computed: {
  	...mapState('param',['gutter']),
  	pkgName () {
  		return this.$i18n.locale == 'zh'?'大流量服务组合':'大流量服務組合'
  	},
  	activeFlag () {
  		return this.$store.state.param.activeFlag
  	},
  },
  methods: {
  	
  },
  created () {
  	//如果是银联 银行卡支付 带有参数?result_type 就直接赋值this.result_type
  	if(this.$route.query.result_type){
  		this.result_type = this.$route.query.result_type
  	}
  	//获取支付方式
  	let pay_type = this.$route.query.pay_type
  	//let pay_type = window.sessionStorage.getItem('pay_type')
  	//获取线上或线下标识
  	if(sessionStorage.getItem("activeFlag")){
  		this.$store.commit('param/setActiveFlag', sessionStorage.getItem('activeFlag'))
  	}
  	//1是信用卡/银行卡  2是中国银联  3是paypal  4是支付宝
  	if(pay_type == '4'){//支付宝
  		this.result_type = (this.$route.query.trade_status == 'TRADE_FINISHED'||this.$route.query.trade_status == 'TRADE_SUCCESS')?'1':'0'
  		this.pay_order_id = this.$route.query.out_trade_no
  	}else if(pay_type == '1'||pay_type == '2'){//银联
  		this.pay_order_id = this.$route.query.Ref
  		if(this.$route.query.result_type){
  			this.result_type = this.$route.query.result_type
  		}else{
  			this.result_type = '1'
  		}
  	}else if(pay_type == '3'){//PayPal
  		//向后台调接口，获取支付状态
  		let tx_q = this.$route.query.tx
  		getPaypalStatus({tx: tx_q})
  		.then(res => {
  			console.log(res)
  			if(res.code === '0'){//接口返回成功
  				if(res.busi_stat === '1'){//支付成功
  					this.result_type = '1'
  					this.pay_order_id = res.order_id
  					//获取支付订单id 传给后台获取订单成功相关信息
  					getOrderInfo({order_id: this.pay_order_id})
				  	.then( res => {
				  		console.log(res)
				  		this.loading = false
				  		if(res.code == 0){//接口返回成功
				  			for(let key in res){
					  			if(this[key]!== undefined){
					  				this[key] = res[key]
					  			}
					  		}
				  		}else{//接口返回失败
				  			
				  		}
				  	})
				  	.catch( err => {
				  		console.log(err)
				  	})
  				}else{//支付失败
  					this.loading = false
  					this.result_type = '0'
  				}
  			}else{//接口返回失败
  				
  			}
  		})
  		.catch( err => {
  			console.log(err)
  		})
  	}
  	//如果支付成功，获取支付订单id 传给后台获取订单成功相关信息
  	if(pay_type != '3'){//除了payPal支付方式以外，payPal要单独走接口判断成功状态
	  	if(this.result_type == '1'){
	  		console.log('支付成功')
	  		getOrderInfo({order_id: this.pay_order_id})
		  	.then( res => {
		  		console.log(res)
		  		this.loading = false
		  		if(res.code == 0){//接口走通
		  			for(let key in res){
			  			if(this[key]!== undefined){
			  				this[key] = res[key]
			  			}
			  		}
		  		}else{//接口报错
		  			
		  		}
		  	})
		  	.catch( err => {
		  		console.log(err)
		  	})
	  	}else{
	  		//支付失败直接显示页面
	  		this.loading = false
	  	}
  	}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.payResult{
	text-align: center;
	color: #333;
	.title{
		font-size: 18px;
		line-height: 18px;
		margin-top: 28px;
		margin-bottom: 20px;
	}
	.box{
		background: #f2f6fa;
		padding: 25px 15px;
		border-radius: 4px;
		text-align: center;
		ul{
			display: inline-block;
			text-align: left;
			font-size: 14px;
			line-height: 22px;
			span{
				color: #666;
			}
			li.red{
				color: #ff7200;
			}
		}
	}
}
.actStep{
	p{
		text-align: center;
		background: #f2f6fa;
	}
	.title{
		font-size: 16px;
		color: #333;
		margin: 0;
		padding-bottom: 15px;
	}
	.step_m{
		img{
			width: 100%;
		}
	}
}
.result{
	.con{
		text-align: right;
	}
}
.tips{
	text-align: center;
	.wrap{
		width: auto;
		display: inline-block;
	}
	.con{
		display: flex;
		align-items: center;
		text-align: left;
	}
	.words{
		margin-left: 15px;
		span{
			color: #0e70c8;
			font-size: 14px;
			font-weight: 700;
		}
	}
}
footer{
	text-align: center;
	line-height: 55px;
	font-size: 12px;
	color: #999;
}
.back{
	display: inline-block;
	font-size: 14px;
	color: #54b1ff;
	margin-top: 15px;
}
.lastStep{
	text-align: center;
	margin-top: 25px;
	a{
		display: inline-block;
		line-height: 48px;
		border: 1px solid #f34d40;
		color: #f34d40;
		padding: 0 40px;
		border-radius: 4px;
	}
}
@media (min-width:768px) {/*pc*/
	.wrap{
		width: 1000px;
		margin: 0 auto;
	}
	.result{
		.con{
			width: 410px;
			margin: 0 auto;
		}
	}
	.actStep:before{
		content: "";
		display: block;
		background: url(../../static/images/act-bg-top.png) no-repeat center;
		height: 87px;
	}
	.actStep:after{
		content: "";
		display: block;
		background: url(../../static/images/act-bg-bt.png) no-repeat center;
		height: 81px;
	}
	.tips{
		padding-bottom: 40px;
	}
}
@media (max-width:767px) {/*phone*/
	.wrap{
		padding: 0 20px;
	}
	.result{
		margin-top: 1rem;
		margin-bottom: 0.75rem;
	}
	.actStep:before{
		width: 100%;
		content: "";
		display: block;
		background: url(../../static/images/act-bg-top-m.png) no-repeat center/100% 2.375rem;
		height: 2.375rem;
	}
	.actStep:after{
		width: 100%;
		content: "";
		display: block;
		background: url(../../static/images/act-bg-bt-m.png) no-repeat center/100% 1.675rem;
		height: 1.675rem ;
	}
	.tips{
		.wrap{
			padding: 0;
		}
		.words{
			margin-left: 0.125rem;
		}
		padding: 1rem 0 0.5rem;
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/payResult.vue